import { render, staticRenderFns } from "./RelationshipInput.vue?vue&type=template&id=36770362&"
import script from "./RelationshipInput.vue?vue&type=script&lang=js&"
export * from "./RelationshipInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports